import { FormFieldColors } from "./types";

const defaultColorScheme = {
  optionDisabledClassName: "text-gray-400 cursor-not-allowed",
};

export const colorScheme: Record<
  FormFieldColors,
  {
    inputClassName: string;
    dropdownClassName: string;
    optionEnabledClassName: string;
    optionDisabledClassName: string;
  }
> = {
  [FormFieldColors.Light]: {
    ...defaultColorScheme,
    inputClassName: "bg-light outline-none",
    dropdownClassName: "bg-light",
    optionEnabledClassName: "hover:bg-neutral hover:font-bold hover:text-primary",
  },
  [FormFieldColors.Neutral]: {
    ...defaultColorScheme,
    inputClassName: "bg-neutral outline-none",
    dropdownClassName: "bg-neutral",
    optionEnabledClassName: "hover:bg-light hover:font-bold hover:text-primary",
  },
};
